import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react";

import { cn } from "@/shared/lib";

import { formatGameTime } from "../format/formatGameTime";
import type { FixOf } from "../model/Fix";

type SoulSource = FixOf<"souls_sources">["params"]["sources"][number]["source"];

const LABEL = msg({
  id: "analysis.fix.souls_sources",
  message: "Souls by {time} compared with strong players on your hero:",
});
const ROW = msg({
  id: "analysis.fix.souls_sources.row",
  message: "{source}: {souls, number} — usually {typical, number}",
});

// Источники душ. `Record` по union из контракта: новый источник не соберётся без подписи.
const SOURCE_LABELS: Record<SoulSource, MessageDescriptor> = {
  lane: msg({ id: "analysis.fix.souls_sources.lane", message: "lane troopers" }),
  neutral: msg({ id: "analysis.fix.souls_sources.neutral", message: "neutral camps" }),
  heroes: msg({ id: "analysis.fix.souls_sources.heroes", message: "hero kills" }),
  objectives: msg({ id: "analysis.fix.souls_sources.objectives", message: "objectives" }),
  treasure: msg({ id: "analysis.fix.souls_sources.treasure", message: "crates and urns" }),
};

// Откуда недобраны души: по источникам против сильных игроков на герое, недобор — первым.
export const SoulsSourcesFix = ({ fix }: { fix: FixOf<"souls_sources"> }) => {
  const { i18n } = useLingui();
  return (
    <div className="mt-1 flex flex-col gap-1 text-sm text-muted">
      <span className="text-foreground-soft">
        {i18n._({ ...LABEL, values: { time: formatGameTime(fix.params.time_s) } })}
      </span>
      <ul className="flex flex-col gap-0.5">
        {fix.params.sources.map((entry) => (
          <li
            key={entry.source}
            className={cn(entry.souls < entry.typical ? "text-warn" : "text-muted")}
          >
            {i18n._({
              ...ROW,
              values: {
                source: i18n._(SOURCE_LABELS[entry.source]),
                souls: entry.souls,
                typical: entry.typical,
              },
            })}
          </li>
        ))}
      </ul>
    </div>
  );
};
